<template>
  <v-sheet rounded class="px-6 py-4 mb-4">
    <v-row>
      <v-col :sm="12">
        <p class="body-1 font-weight-bold mb-0 navy--text text--darken-1 mb-2">
          Věk
        </p>
      </v-col>
      <v-col :sm="12" class="pt-0">
        <div class="c-rangeSlider">
          <v-range-slider
            height="4"
            :min="minAge"
            :max="maxAge"
            color="info"
            track-color="navy lighten-2"
            hide-details="auto"
            :thumb-label="true"
            :value="age"
            @input="onAgeInput"
          >
            <template v-slot:prepend>
              <div class="c-rangeSlider__num">
                {{ ageFrom }}
              </div>
            </template>

            <template v-slot:append>
              <div class="c-rangeSlider__num">
                {{ ageTo }}
              </div>
            </template>
          </v-range-slider>
        </div>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
export default {
  name: "Age",
  props: {
    ageFrom: {
      type: Number,
      default: 13,
    },
    ageTo: {
      type: Number,
      default: 65,
    },
    maxAge: {
      type: Number,
      default: 65,
    },
    minAge: {
      type: Number,
      default: 13,
    },
  },
  computed: {
    age() {
      return [this.ageFrom, this.ageTo]
    },
  },
  methods: {
    onAgeInput(val) {
      if (val[0] < this.minAge) {
        val[0] = this.minAge
      }
      if (val[1] > this.maxAge) {
        val[1] = this.maxAge
      }

      this.$emit("input", val)
    },
  },
}
</script>

<style scoped>
.c-rangeSlider {
  position: relative;
}

.c-rangeSlider__num {
  width: 20px;
  position: relative;
  top: -7px;
  font-size: 11px;
  font-weight: bold;
}
</style>
